import React from 'react';
import { formatCurrency } from '../../../../../utils/format';
import { upperCase } from 'lodash';
import currency from 'currency.js';
import { STORAGE_URL, MODO_IMPRESSAO } from '~/constants';
import NotFound from '~/assets/not-found.png';
import { useSelector } from 'react-redux';
import { useTheme } from '@material-ui/core/styles';

const ItensTable = ({ itens = [], separaPorAmbiente, habilitaImagem, modoImpressao }) => {

  const theme = useTheme();
  const a5 = modoImpressao !== MODO_IMPRESSAO.A4;
  const corZebra = theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.08)' : '#ececec';
  const totalCols = (a5 ? 9 : 10) + (habilitaImagem ? 1 : 0);
  const moeda = valor => a5 ? formatCurrency(valor).replace('R$ ', 'R$') : formatCurrency(valor);
  const corExata = { WebkitPrintColorAdjust: 'exact', printColorAdjust: 'exact' };
  const cA5 = (align = 'left', extra = {}) => ({
    verticalAlign: 'middle',
    textAlign: align,
    whiteSpace: 'nowrap',
    padding: `var(--half-spacing-size) var(--horizontal-item-grid-spacing)`,
    borderBottom: '1px solid rgba(128, 128, 128, 0.35)',
    ...extra,
  });
  const headerA5 = (
    <tr className='main-cells no-break'>
      {habilitaImagem && <th style={cA5('left')}>Img.</th>}
      <th style={cA5('left')}>#</th>
      <th style={cA5('left', { whiteSpace: 'normal', width: '100%' })}>Código - Descrição</th>
      <th style={cA5('center', { width: '1%', padding: `var(--half-spacing-size) calc(var(--horizontal-item-grid-spacing) / 2)` })}>Uni.</th>
      <th style={cA5('center', { width: '1%', padding: `var(--half-spacing-size) calc(var(--horizontal-item-grid-spacing) / 2)` })}>Qtd.</th>
      <th style={cA5('right')}>Pr.Bruto</th>
      <th style={cA5('right')}>Desc.</th>
      <th style={cA5('right')}>Acrés.</th>
      <th style={cA5('right')}>Pr.Líquido</th>
      <th style={cA5('right')}>Total</th>
    </tr>
  );

  const { selects } = useSelector(state => state.pdv);
  const itensPorAmbiente = new Map();

  itens.forEach(item => {
    let ambiente = "SEM AMBIENTE"

    if (separaPorAmbiente) {
      let itemAmbiente = item?.estProdutoAmbiente;
      const ambienteVazio = !itemAmbiente || Object.keys(itemAmbiente).length === 0;

      if (ambienteVazio && item?.estProdutoAmbienteId) {
        itemAmbiente = (selects?.ambientes ?? []).find(
          ambiente => ambiente.id === item.estProdutoAmbienteId
        );
      }

      item = {
        ...item,
        estProdutoAmbiente: itemAmbiente,
      };

      ambiente = item.estProdutoAmbiente?.descricao || "SEM AMBIENTE"
    }

    if (!itensPorAmbiente.has(ambiente)) {
      itensPorAmbiente.set(ambiente, {
        itens: [],
        totalQuantidade: Number(
          currency(0, {precision: 2})
        ),
        totalValor: Number(
          currency(0, {precision: 2})
        ),
        totalPrecoBruto: Number(
          currency(0, {precision: 2})
        ),
        totalDesconto: Number(
          currency(0, {precision: 2})
        ),
        totalAcrescimo: Number(
          currency(0, {precision: 2})
        ),
        totalPrecoLiquido: Number(
          currency(0, {precision: 2})
        ),
      });
    }

    const ambienteData = itensPorAmbiente.get(ambiente);
    ambienteData.itens.push(item);

    ambienteData.totalQuantidade = Number(
      currency(ambienteData.totalQuantidade, {precision: 2})
      .add(item.itemQuantidade)
    );

    ambienteData.totalPrecoBruto = Number(
      currency(ambienteData.totalPrecoBruto, {precision: 2})
      .add(item.itemValorUnitario)
    );

    ambienteData.totalDesconto = Number(
      currency(ambienteData.totalDesconto, {precision: 2})
      .add(item.itemValorDesconto)
    );

    ambienteData.totalAcrescimo = Number(
      currency(ambienteData.totalAcrescimo, {precision: 2})
      .add(item.itemValorAcrescimo)
    );

    ambienteData.totalPrecoLiquido = Number(
      currency(ambienteData.totalPrecoLiquido, {precision: 2})
      .add(item.itemValorTotal / item.itemQuantidade)
    );

    ambienteData.totalValor = Number(
      currency(ambienteData.totalValor, {precision: 2})
      .add(item.itemValorTotal)
    );

    itensPorAmbiente.set(ambiente, ambienteData);
  })

  let itemCounter = 0

  return (
    <>

      <style>{`
        .main-cells th:first-child,
        .main-cells td:first-child {
          padding-left: var(--spacing-size) !important;
        }

        .main-cells th:last-child,
        .main-cells td:last-child {
          padding-right: var(--spacing-size) !important;
        }
      `}</style>

      <div className='scrollable' style={{ border: '1px solid black', borderBottom: 'none', overflowX: 'auto', ...(a5 ? { borderTop: 'none', padding: '0 var(--half-spacing-size)' } : {}) }}>

        {!a5 && (
          <div style={{ fontSize: 'var(--section-title-text-size)', fontWeight: '700', padding: 'var(--spacing-size)', paddingBottom: separaPorAmbiente ? '0px' : 'var(--half-spacing-size)' }}>
            ITENS
          </div>
        )}

        <table
          style={{
            fontSize: 'var(--regular-text-size)',
            width: '100%',
            borderCollapse: 'collapse',
            tableLayout: 'auto',
          }}
        >

          {itens.length === 0 ? (

            <tr className='no-break'>
              <td colSpan={totalCols} style={{ padding: 0, padding: `var(--half-spacing-size) 0px` }}>
                <div style={{ borderBottom: '1px solid black', margin: `var(--half-spacing-size) var(--spacing-size)` }} />
                <div style={{ paddingLeft: 'var(--spacing-size)', paddingRight: 'var(--spacing-size)', paddingTop: 'var(--half-spacing-size)', paddingBottom: 'var(--half-spacing-size)' }}>
                  <div style={{ fontSize: 'var(--regular-text-size)', paddingBottom: 'var(--half-spacing-size)', fontWeight: '500' }}>
                    SEM ITENS
                  </div>
                </div>
              </td>
            </tr>

          ) : (

            <>
              {!separaPorAmbiente && (
                a5 ? headerA5 : (
                <React.Fragment>
                  <tr>
                    <td colSpan={totalCols} style={{ padding: 0, paddingLeft: 'var(--spacing-size)', paddingRight: 'var(--spacing-size)' }}>
                      <div style={{ borderBottom: '1px solid black', margin: `var(--half-spacing-size) 0px` }} />
                    </td>
                  </tr>
                  <tr className='main-cells no-break'>
                    { habilitaImagem &&
                      <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Img.</th>
                    }
                    <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>#</th>
                    <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Cód.</th>
                    <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere', minWidth: '80px' }}>Descrição</th>
                    <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Unid</th>
                    <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Qtd</th>
                    <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Pr.Bruto</th>
                    <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Desc.</th>
                    <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Acrésc.</th>
                    <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Pr.Líquido</th>
                    <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Total</th>
                  </tr>
                  <tr>
                    <td colSpan={totalCols} style={{ padding: 0, paddingLeft: 'var(--spacing-size)', paddingRight: 'var(--spacing-size)' }}>
                      <div style={{ borderBottom: '1px dashed black', margin: `var(--half-spacing-size) 0px` }} />
                    </td>
                  </tr>
                </React.Fragment>
                )
              )}

              <tbody>

                {Array.from(itensPorAmbiente.entries()).sort(([ambiente1], [ambiente2]) => {
                  if (ambiente1 === "SEM AMBIENTE") return 1
                  if (ambiente2 === "SEM AMBIENTE") return -1
                  return ambiente1.localeCompare(ambiente2, 'pt-BR', { sensitivity: 'base' })
                }).map(([ambiente, data], ambienteIdx) => (

                  <React.Fragment key={ambienteIdx}>
                    {separaPorAmbiente && (
                      <tr className='no-break'>
                        <td colSpan={totalCols} style={{ padding: 0, padding: `var(--half-spacing-size) 0px` }}>
                          <div style={{ borderBottom: '1px solid black', margin: `var(--half-spacing-size) var(--spacing-size)` }} />
                          <div style={{ paddingLeft: 'var(--spacing-size)', paddingRight: 'var(--spacing-size)', paddingTop: 'var(--half-spacing-size)' }}>
                            <div style={{ paddingBottom: 'var(--half-spacing-size)' }}>
                              <span style={{ fontSize: 'var(--regular-text-size)', fontWeight: 500 }}>Ambiente:</span>{' '}
                              <span style={{ fontSize: 'var(--section-title-text-size)', fontWeight: 700 }}>{upperCase(ambiente)}</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}

                    {separaPorAmbiente && (a5 ? headerA5 : (
                      <React.Fragment>
                        <tr className='main-cells no-break'>
                          { habilitaImagem &&
                            <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap',  }}>Img.</th>
                          }
                          <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>#</th>
                          <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Cód.</th>
                          <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere', minWidth: '80px' }}>Descrição</th>
                          <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Unid</th>
                          <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Qtd</th>
                          <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Pr.Bruto</th>
                          <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Desc.</th>
                          <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Acrésc.</th>
                          <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Pr.Líquido</th>
                          <th style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>Total</th>
                        </tr>
                        <tr>
                          <td colSpan={totalCols} style={{ padding: 0, paddingLeft: 'var(--spacing-size)', paddingRight: 'var(--spacing-size)' }}>
                            <div style={{ borderBottom: '1px dashed black', margin: `var(--half-spacing-size) 0px` }} />
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}

                    {[...data.itens].sort((item1, item2) => {
                      return item1.produtoDescricao.localeCompare(item2.produtoDescricao, 'pt-BR', {sensitivity: 'base'})
                    }).map((item) => {

                      itemCounter++;
                      const cZebra = (align, extra = {}) => cA5(align, { background: itemCounter % 2 === 0 ? corZebra : 'transparent', ...corExata, ...extra });
                      let imgUrl = item?.produtoEstProduto?.foto ? `${STORAGE_URL}produtos/${item?.produtoEstProduto?.foto}` : ''
                      return (
                        a5 ? (
                          <tr key={itemCounter} className={`main-cells no-break${itemCounter % 2 === 0 ? ' zebra-row' : ''}`}>
                            {habilitaImagem && (
                              <td style={cZebra('left')}>
                                <img src={imgUrl || NotFound} alt="Img" style={{width: 'var(--item-img-size)', height: 'var(--item-img-size)'}} />
                              </td>
                            )}
                            <td style={cZebra('left')}>{itemCounter}</td>
                            <td style={cZebra('left', { whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'break-word' })}>{item.produtoCodigo} - {item.produtoDescricao}</td>
                            <td style={cZebra('center', { padding: `var(--half-spacing-size) calc(var(--horizontal-item-grid-spacing) / 2)` })}>{item.produtoUnidadeComercial}</td>
                            <td style={cZebra('center', { padding: `var(--half-spacing-size) calc(var(--horizontal-item-grid-spacing) / 2)` })}>{item.itemQuantidade}</td>
                            <td style={cZebra('right')}>{moeda(item.itemValorUnitario)}</td>
                            <td style={cZebra('right')}>{moeda(item.itemValorDesconto)}</td>
                            <td style={cZebra('right')}>{moeda(item.itemValorAcrescimo)}</td>
                            <td style={cZebra('right')}>{moeda(item.itemValorTotal / item.itemQuantidade)}</td>
                            <td style={cZebra('right')}>{moeda(item.itemValorTotal)}</td>
                          </tr>
                        ) :
                        <tr className='main-cells no-break'>
                          { habilitaImagem &&
                            <td style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)` }}>
                              <img src={imgUrl || NotFound} alt="Img" style={{width: 'var(--item-img-size)', height: 'var(--item-img-size)'}} />
                            </td>
                          }
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>{itemCounter}</td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>{item.produtoCodigo}</td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'break-word', width: '100%', maxWidth: '80%' }}>{item.produtoDescricao}</td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>{item.produtoUnidadeComercial}</td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>{item.itemQuantidade}</td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(item.itemValorUnitario)}</td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(item.itemValorDesconto)}</td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(item.itemValorAcrescimo)}</td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(item.itemValorTotal / item.itemQuantidade)}</td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(item.itemValorTotal)}</td>
                        </tr>
                      );
                    })}

                    {separaPorAmbiente && a5 && (
                      <tr className='main-cells no-break' style={{ fontWeight: '700' }}>
                        <td colSpan={totalCols - 1} style={cA5('right')}>SUBTOTAL:</td>
                        <td style={cA5('right')}>{moeda(data.totalValor)}</td>
                      </tr>
                    )}

                    {separaPorAmbiente && !a5 && (
                      <React.Fragment>
                        <tr>
                          <td colSpan={totalCols} style={{ padding: 0, paddingLeft: 'var(--spacing-size)', paddingRight: 'var(--spacing-size)' }}>
                            <div style={{ borderBottom: '1px dashed black', margin: `var(--half-spacing-size) 0px` }} />
                          </td>
                        </tr>
                        <tr className='main-cells no-break' style={{ fontWeight: '700' }}>
                          { habilitaImagem &&
                            <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}></td>
                          }
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}></td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}></td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}></td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}></td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}></td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}></td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}></td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}></td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) 0px`, textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word' }}>SUBTOTAL:</td>
                          <td style={{ verticalAlign: 'top', padding: `calc(var(--vertical-item-grid-spacing)/2) var(--horizontal-item-grid-spacing)`, textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(data.totalValor)}</td>
                        </tr>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
              <tr>
                <td colSpan={totalCols} style={{ paddingTop: 'var(--spacing-size)' }}></td>
              </tr>
            </>

          )}

        </table>
      </div>
    </>
  );


};

export default ItensTable;
